import BookList from "layouts/book/book-list";
import EditBook from "layouts/book/edit-book";
import NewBook from "layouts/book/new-book";
import QuizList from "layouts/quiz/quiz-list";
import EditQuiz from "layouts/quiz/edit-quiz";
import NewQuiz from "layouts/quiz/new-quiz";
import MaterialList from "layouts/material/material-list";
import EditMaterial from "layouts/material/edit-material";
import NewMaterial from "layouts/material/new-material";
import MineSoundMaterials from "layouts/sound-material/sound-material/mine-sound-materials";
import SelectedMaterial from "layouts/sound-material/sound-material/selected-material";
import SelectMaterial from "layouts/sound-material/sound-material/select-material";
import CreateSoundMaterial from "layouts/sound-material/sound-material";
import SelectItemLetter from "layouts/sound-material/sound-item/select-item-letter";
import NewSoundItem from "../layouts/sound-material/sound-item/index";
import SoundItems from "../layouts/sound-material/sound-item/mine-sound-items";
import NewOrganization from "../layouts/organization/new-organization";
import OrganizationList from "../layouts/organization/organization-list";
import EditOrganization from "../layouts/organization/edit-organization";
import SubOrganizationList from "../layouts/sub-organization/sub-organization-list";
import EditSubOrganization from "../layouts/sub-organization/edit-sub-organization";
import NewSubOrganization from "../layouts/sub-organization/new-sub-organization";
import EditClass from "../layouts/class/edit-class";
import NewClass from "../layouts/class/new-class";
import ClassList from "../layouts/class/class-list";
import NewUser from "../layouts/user/new-user";
import UserList from "../layouts/user/user-list";
import EditUser from "../layouts/user/edit-user";
import UserImport from "../layouts/user/user-import";

export const screenComponentMapping = {
  LIST_BOOK: BookList,
  ADD_BOOK: NewBook,
  EDIT_BOOK: EditBook,
  LIST_QUIZ: QuizList,
  ADD_QUIZ: NewQuiz,
  EDIT_QUIZ: EditQuiz,
  LIST_MATERIAL: MaterialList,
  ADD_MATERIAL: NewMaterial,
  EDIT_MATERIAL: EditMaterial,
  ADD_SOUND_ITEM: SelectItemLetter,
  ADD_SOUND_ITEM_FORM: NewSoundItem,
  CREATE_SOUND_MATERIAL: CreateSoundMaterial,
  SELECT_SOUND_MATERIAL: SelectMaterial,
  SELECTED_MATERIALS: SelectedMaterial,
  SOUND_MATERIALS: MineSoundMaterials,
  MINE_SOUND_ITEMS: SoundItems,
  ADD_ORGANIZATION: NewOrganization,
  LIST_ORGANIZATION: OrganizationList,
  EDIT_ORGANIZATION: EditOrganization,
  LIST_SUBORGANIZATION: SubOrganizationList,
  EDIT_SUBORGANIZATION: EditSubOrganization,
  ADD_SUBORGANIZATION: NewSubOrganization,
  EDIT_CLASS: EditClass,
  ADD_CLASS: NewClass,
  LIST_CLASS: ClassList,
  ADD_USER: NewUser,
  LIST_USER: UserList,
  EDIT_USER: EditUser,
  IMPORT_USER: UserImport,
};
